export const LearnVideos = [
  {
    thumbnail: './assets/images/video-thumbnail.svg',
    videoSource: '',
    title: 'Gold Loan Explained',
    desc: 'When technology has changed how we shop, why should gold be left behind?',
  },
  {
    thumbnail: './assets/images/video-thumbnail.svg',
    videoSource: '',
    title: 'Gold Loan Explained',
    desc: 'When technology has changed how we shop, why should gold be left behind?',
  },
  {
    thumbnail: './assets/images/video-thumbnail.svg',
    videoSource: '',
    title: 'Gold Loan Explained',
    desc: 'When technology has changed how we shop, why should gold be left behind?',
  },
  {
    thumbnail: './assets/images/video-thumbnail.svg',
    videoSource: '',
    title: 'Gold Loan Explained',
    desc: 'When technology has changed how we shop, why should gold be left behind?',
  },
  {
    thumbnail: './assets/images/video-thumbnail.svg',
    videoSource: '',
    title: 'Gold Loan Explained',
    desc: 'When technology has changed how we shop, why should gold be left behind?',
  },
  {
    thumbnail: './assets/images/video-thumbnail.svg',
    videoSource: '',
    title: 'Gold Loan Explained',
    desc: 'When technology has changed how we shop, why should gold be left behind?',
  },
  {
    thumbnail: './assets/images/video-thumbnail.svg',
    videoSource: '',
    title: 'Gold Loan Explained',
    desc: 'When technology has changed how we shop, why should gold be left behind?',
  },
];
